import { Injectable, InjectionToken } from '@angular/core';

// todo: define keys and expected value types
// todo: validate values with zod or similar

export const BROWSER_STORAGE = new InjectionToken<Storage>(
  'Browser Storage',
  {
    providedIn: 'root',
    factory: () => sessionStorage,
  },
);

export function storageServiceFactory(
  namespace: string,
  version: number,
) {
  return (storage: Storage): StorageService =>
    new StorageService(storage, namespace + '-' + version);
}

@Injectable({
  providedIn: 'root',
  useFactory: storageServiceFactory('global', 1),
  deps: [BROWSER_STORAGE],
})
export class StorageService {
  constructor(
    private storage: Storage,
    private namespace: string,
  ) {}

  get<T>(key: string, defaultValue?: T): T {
    const map = this.getStorageObject();
    const value = map.get(key);
    // todo: check if value is of type T
    return value !== undefined ? (value as T) : defaultValue;
  }

  has(key: string): boolean {
    const map = this.getStorageObject();
    return map.has(key);
  }

  set<T>(key: string, value: T) {
    const map = this.getStorageObject();
    map.set(key, value);
    this.writeStorageObject(map);
  }

  remove(key: string) {
    const map = this.getStorageObject();
    map.delete(key);
    this.writeStorageObject(map);
  }

  clear() {
    this.storage.removeItem(this.namespace);
  }

  size(): number {
    const map = this.getStorageObject();
    return map.size;
  }

  private getStorageObject(): Map<string, unknown> {
    const objString = this.storage.getItem(this.namespace);
    let map: Map<string, unknown>;
    try {
      map = new Map(JSON.parse(objString));
    } catch (error) {
      console.warn('Could not get storage: ' + error);
      map = new Map();
    }
    return map;
  }

  private writeStorageObject(map: Map<string, unknown>) {
    try {
      const objString = JSON.stringify(Array.from(map.entries()));
      this.storage.setItem(this.namespace, objString);
    } catch (error) {
      console.error('Could not write to storage: ' + error);
    }
  }
}
